// extracted by mini-css-extract-plugin
export var dropdownButton = "_3w-0";
export var fullWidthDropdownButton = "_3w-1";
export var icon = "_3w-3";
export var iconPlaceholder = "_3w-2";
export var menuItemRow = "_3w-9";
export var separator = "_3w-e";
export var shortcutContainer = "_3w-7";
export var shortcutContainerFilled = "_3w-8";
export var shortcutIconLg = "_3w-6";
export var shortcutIconMd = "_3w-5";
export var shortcutIconSm = "_3w-4";
export var submenuChevron = "_3w-d";
export var submenuDropdown = "_3w-a";
export var submenuTriggerRow = "_3w-b";
export var submenuTriggerRowOpen = "_3w-c";